import React, { useState, useContext, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate, Link } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { AuthContext } from '../AuthContext'; 
import './login.css';

export default function Login() {
  const [errors, setErrors] = useState('');
  const baseUrl = process.env.REACT_APP_SECOND_BACKEND_URL;
  const navigate = useNavigate();
  const { login,token} = useContext(AuthContext);
  
  const roleRedirects = {
    admin: "/adminDash",
    bank_owner: "/bankOwnerDash",
    customer: "/customerDash",
    farmer: "/farmerDash",
    hotel_owner: "/hotelOwnerDash",
    transport_owner: "/transportOwnerDash",
  };
  const checkToken=()=>{
    if(token){
      const decodedToken=jwtDecode(token)
      navigate(roleRedirects[decodedToken?.sub?.role])
    }
    
  }
  useEffect(()=>{
   checkToken()
  },[token])
  const formik = useFormik({
    initialValues: {
      username: "",
      password: ""
    },
    validationSchema: Yup.object().shape({
      username: Yup.string().required("Username is required").typeError("Enter a valid username"),
      password: Yup.string().required("Password is required").typeError("Please enter a valid password")
    }),
    onSubmit: async (values, { setSubmitting }) => {
    try {
      await loginUser(values);      
      formik.resetForm()      
    } catch (error) {
      console.error(`An error ocurred logging in ${error}`)
    }
    finally{      
      setSubmitting(false)
     
    }
    }
  });

  const loginUser = async (values) => {
    try {
      const res = await fetch(`${baseUrl}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(values)
      });

    
      const data = await res.json();
      if(!res.ok){
        if(res.status===500){
          setErrors("An unexpected error occured ,please try again")
          return
        }
        else{
          setErrors(data.Error || data.Message)
          return
        }
      }
      if (data.token) { 
        login(data.token);
        const decodedToken = jwtDecode(data.token);
        const role = decodedToken.sub.role;

        alert(`You are a ${role}, you have logged in successfully`);
        navigate(roleRedirects[role] || "/");
      }
    } catch (error) {
      console.error(`An error occurred logging in: ${error}`);
      setErrors("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 mt-2">
    <div className="w-full max-w-2xl p-5 bg-white rounded-3xl border shadow-md lg:max-w-4xl lg:p-10 lg:m-2">
      <form onSubmit={formik.handleSubmit} className="flex flex-col">
      <label htmlFor="username" className='max-w-full min-w-fit font-bold mt-4 mb-4 text-2xl'>Username</label>
        <input
          type="text"
          name="username"
          value={formik.values.username}
          placeholder="Enter your username"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className='max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl text-center'
        />
        {formik.touched.username && formik.errors.username && <p className='text-red-500 italic'>{formik.errors.username}</p>}
        
        <label htmlFor="password" className='max-w-full min-w-fit font-bold mt-4 mb-4 text-2xl'>Password</label>
        <input
          id="password"
          type="password"
          name="password"
          value={formik.values.password}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className='max-w-full min-w-fit  bg-blue-50 h-12 rounded-2xl mb-6 items-center justify-center text-center'
        />
        {formik.touched.password && formik.errors.password && <p className="text-red-500 italic">{formik.errors.password}</p>}
        
        <button type="submit" className="max-w-full min-w-fit bg-blue-500 disabled:opacity-50 h-12 rounded-2xl mb-6" disabled={formik.isSubmitting || !formik.isValid}>{formik.isSubmitting?<h1>Loggingin...</h1>:<h1>Login</h1>}</button>
        
        {errors.length>0? <p className="text-red-500 mt-2">{errors}</p>:null}
        <p className=' italic'>Don't have an account: 
        <Link to="/registerUser" className='text-blue-500 ml-2 text-lg'>Register</Link>
      </p>
      </form>
    </div>
  </div>
  );
}


